import type { Lang } from '../i18n'

export interface AppContextType {
  lang: Lang
  setLang: (l: Lang) => void
  dark: boolean
  setDark: (d: boolean) => void
}

export const APP_CONTEXT_INITIAL_STATE: AppContextType = {
  lang: 'ar',
  setLang: () => {},
  dark: false,
  setDark: () => {},
}